import { createFileRoute } from '@tanstack/react-router';
import { SettingsIndexPage } from './settings.js';

export const Route = createFileRoute('/$workspaceSlug/settings')({
  component: SettingsIndexPage,
});
